import { FileValidatorService } from './file-validator.service';

export default angular
  .module('sfMobile.services.file-validator', [])
  .service('fileValidatorService', FileValidatorService).name;
